const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Converts a relative image path (e.g., /api/uploads/xxx.png) to a full URL.
 * If the path is already an absolute URL (starts with http), returns as-is.
 */
export function getImageUrl(path) {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const base = API_URL?.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
}
